<template>
    <div v-if="audit">
        <f-dialog
            :title  = "$t('audit.rebuild.query')"
            v-model = "confirmRebuild"
            :width  = "450"
            store-label="Berichte erstellen"
            :show-cancel = "false"
            @cancel = "onCancelRebuild"
            @store  = "onRebuild"
        >
            <template v-slot:preaction>
                <div class="text-center w-100">
                    <v-switch
                        v-if    = "!gbuIsEscalator"
                        v-model = "recalculate"
                        :label  = "$t('audit.rebuild.label')"
                        :ripple = "false"
                        class   = "pt-0 mt-0"
                        hide-details
                    />
                </div>
            </template>

            <template v-slot:content>
                <div class="pa-2" v-html="$t('audit.rebuild.text')"></div>
                <div class="pa-2 mb-2" v-if="!gbuIsEscalator" v-html="$t('audit.rebuild.recalculate')"></div>
            </template>
        </f-dialog>

        <p-audit-history
            v-model      = "delta.show"
            :audit       = "delta.audit"
            :type        = "delta.type"
            :device-type = "delta.deviceType"
        />

        <v-row class="no-frame mt-2">
            <v-col class="pa-0 no-border" :class="showEsg ? 'main-first-2-col pr-3' : ''">
                <c-audit-overview
                    class             = "h-100"
                    :data             = "audit.gbu"
                    :country          = "unit.country.iso3166"
                    :height           = "690"
                    type              = "GBU"
                    :device-type      = "gbuDeviceType"
                    :show-budget-data = "true"
                >
                    <template v-slot:toolbar>
                        <div class="v-flex white--text mr-3" v-if="audit.gbu">
                            {{ audit.user }}
                            <div class="mr-2">
                                {{ formatDate (audit.gbu.date) }}
                            </div>
                            <div>
                                {{ audit.gbu.user ? audit.gbu.user.surname : '---' }}
                            </div>
                        </div>
                    </template>

                    <template v-slot:overlay>
                        <div>
                            <c-fab-menu
                                icon     = "mdi-history"
                                :label   = "$t('audit.history')"
                                :menu    = "history.gbu"
                                :columns = "2"
                                @entry   = "onGbuSelected"
                            />
                        </div>

                        <div class="mt-3" v-if="isPlanner">
                            <c-fab-button
                                icon     = "mdi-delta"
                                :label   = "$t('audit.delta.label')"
                                @click   = "onGbuDelta"
                            />
                        </div>

                        <div class="mt-3">
                            <c-fab-menu
                                icon     = "mdi-printer"
                                :label   = "$t('audit.report.title')"
                                :menu    = "reports.gbu"
                                :columns = "1"
                                @entry   = "onGbuReport"
                            />
                        </div>

                        <div class="mt-3" v-if="isPlanner && !gbuIsEscalator">
                            <c-fab-menu
                                icon     = "mdi-calculator"
                                :label   = "$t('audit.recalc.title')"
                                :menu    = "calculator.gbu"
                                :columns = "1"
                                @entry   = "onGbuRecalc"
                            />
                        </div>
                    </template>
                </c-audit-overview>
            </v-col>
            <v-col class="main-first-2-col pa-0 pl-3 no-border" v-if="showEsg">
                <c-audit-overview
                    class             = "h-100"
                    :data             = "audit.esg"
                    :height           = "690"
                    :country          = "unit.country.iso3166"
                    type              = "ESG"
                    :show-budget-data = "true"
                >
                    <template v-slot:toolbar>
                        <div class="v-flex white--text mr-3" v-if="audit.esg">
                            <div class="mr-2">
                                {{ formatDate (audit.esg.date) }}
                            </div>
                            <div>
                                {{ audit.esg.user ? audit.esg.user.surname : '---' }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:overlay>
                        <div>
                            <c-fab-menu
                                icon     = "mdi-history"
                                :label   = "$t('audit.history')"
                                :menu    = "history.esg"
                                :columns = "2"
                                @entry   = "onEsgSelected"
                            />
                        </div>

                        <div class="mt-3" v-if="isPlanner">
                            <c-fab-button
                                icon     = "mdi-delta"
                                :label   = "$t('audit.delta.label')"
                                @click   = "onEsgDelta"
                            />
                        </div>

                        <div class="mt-3">
                            <c-fab-menu
                                icon     = "mdi-printer"
                                :label   = "$t('audit.report.title')"
                                :menu    = "reports.esg"
                                :columns = "1"
                                @entry   = "onEsgReport"
                            />
                        </div>
                    </template>
                </c-audit-overview>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import Audit          from "@/modules/audit/service/Audit";
import CAuditOverview from "@/modules/audit/components/CAuditOverview.vue";
import CFabMenu       from "@/modules/core/components/utils/CFabMenu.vue";
import FDialog        from "@/modules/core/components/utils/FDialog.vue";
import CFabButton from "@/modules/core/components/utils/CFabButton.vue";
import PAuditHistory from "@/modules/audit/components/private/PAuditHistory.vue";
import Site           from "@/modules/msd/unit/service/Site";
import AuditType      from "@/modules/audit/service/AuditType";

export default {
    name: "CAudits",

    components: {
        PAuditHistory,
        CFabButton,
        FDialog,
        CFabMenu,
        CAuditOverview,
    },

    props: {
        unit: {

        },
    },

    data: () => ({
        confirmRebuild: false,
        recalculate: true,
        reports: {
            gbu: [
            ],
            esg: [
            ],
        },

        audit: {
            gbu : null,
            esg : null,
        },

        history: {
            gbu : null,
            esg : null,
        },

        calculator: {
            gbu: null
        },

        delta: {
            show: false,
            audit: null,
            type: null,
            deviceType: null
        }
    }),

    computed: {
        isPlanner () {
            return Core.security.isPlanner()
        },

        /** GBU type of the shown GBU, from the audit (HCIT-917), not from the master data. */
        gbuDeviceType () {
            return AuditType.deviceType(this.audit.gbu);
        },

        gbuIsEscalator () {
            return AuditType.isEscalator(this.audit.gbu);
        },

        /** ESG: always for elevators; for escalators only while older ESG audits exist (HCIT-917 F3). */
        showEsg () {
            return AuditType.showEsg(Site.isEscalator(this.unit), this.history.esg);
        }
    },

    mounted() {
        this.buildMenu();
        this.load();
    },

    watch: {
        unit () {
            this.load();
        }
    },

    methods: {
        load () {
            if (!this.unit) {
                return;
            }

            Audit.history(this.unit, "GBU").then(history => {
                this.history.gbu = [];
                if (history && history.length > 0) {
                    history.forEach (entry => {
                        this.history.gbu.push ({
                            id    : entry.id,
                            column: [ this.formatDate(entry.date), entry.technician ]
                        });
                    });

                    this.loadGbu(history[0].id);
                }
            });

            Audit.history(this.unit, "ESG").then(history => {
                this.history.esg = [];
                if (history && history.length > 0) {
                    history.forEach (entry => {
                        this.history.esg.push ({
                            id    : entry.id,
                            column: [ this.formatDate(entry.date), entry.technician ]
                        });
                    });

                    this.loadEsg(history[0].id);
                }
            });
        },

        loadGbu (auditId) {
            Audit.findById(auditId).then(audit => {
                // the escalator catalogue is loaded again if it failed at the start
                const catalogue = AuditType.isEscalator(audit) && !this.$store.getters.auditEscalator
                    ? this.$store.dispatch('initAuditEscalatorEnums')
                    : Promise.resolve();

                return catalogue.then(() => {
                    this.audit.gbu = audit;
                    this.buildMenu();
                });
            })
        },

        loadEsg (auditId) {
            Audit.findById(auditId).then(audit => {
                this.audit.esg = audit;
            })
        },

        onGbuSelected (entry) {
            this.loadGbu(entry.id);
        },

        onGbuReport (entry) {
            if (entry.id === 1) {
                this.onRebuildConfirm();
                return;
            }

            Audit.report(this, entry.id, this.audit.gbu.id, entry.name);
        },

        onGbuRecalc (entry) {
            if (entry.id !== 1) {
                return;
            }

            Core.message.confirm(
                this,
                this.$t('audit.recalc.budget.query'),
                this.$t('audit.recalc.budget.text'),
                Core.message.Default,
                (value) => {
                    if (value) {
                        Audit.recalculate(this.audit.gbu.id).then (() => {
                            Audit.findById(this.audit.gbu.id).then(audit => {
                                this.audit.gbu = audit;
                                Core.message.alert.save(this);
                            })
                        });
                    }
                })
        },

        onGbuDelta () {
            this.delta.audit = this.audit.gbu;
            this.delta.show = true;
            this.delta.type = "GBU";
            this.delta.deviceType = this.gbuDeviceType;
        },

        onEsgDelta () {
            this.delta.audit = this.audit.esg;
            this.delta.show = true;
            this.delta.type = "ESG";
            this.delta.deviceType = null;
        },

        onEsgReport (entry) {
            Audit.report(this, entry.id, this.audit.esg.id, entry.name);
        },

        onEsgSelected (entry) {
            this.loadEsg(entry.id);
        },

        onRebuildConfirm () {
            this.confirmRebuild = true;
        },

        onRebuild () {
            Core.loading(this, true);
            // elevator unchanged (always recalculated); escalator GBUs have no costs
            Audit.rebuildReports (this.audit.gbu.inspectionId, !this.gbuIsEscalator).then (() => {
                Core.loading(this, false);
                Core.message.hint(this, this.$t('audit.rebuild.success'))
                this.confirmRebuild = false;
            }).catch(error => {
                Core.loading(this, false);
                console.log("error", error)
                Core.message.error(this, error);
                this.confirmRebuild = false;
            });
        },

        onCancelRebuild () {
            this.confirmRebuild = false;
        },

        buildMenu () {
            this.reports.gbu = [];
            this.reports.esg = [];
            this.calculator.gbu = [];

            this.reports.gbu.push({ id: 110, name: this.$t('audit.report.comparison')})
            this.reports.gbu.push({ id: 113, name: this.$t('audit.report.assessment')})
            this.reports.gbu.push({ id: 111, name: this.$t('audit.report.adaptation')})
            this.reports.gbu.push({ id: 112, name: this.$t('audit.report.estimation')})

            if (this.audit && this.audit.gbu && this.audit.gbu.inspectionId) {
                this.reports.gbu.push({ id: null})
                this.reports.gbu.push({ id: 1,   name: this.$t('audit.report.rebuild')})
            }

            // escalator GBU: no cost estimation (HCIT-917, Festlegung 10)
            this.reports.gbu = AuditType.reports(this.gbuDeviceType, this.reports.gbu);

            this.reports.esg.push({ id: 115, name: this.$t('audit.report.esg')})

            this.calculator.gbu.push({ id: 1, name: this.$t('audit.recalc.budget.title') })
        },

        formatDate (value) {
            return Core.format.date.display(value);
        },
    }
}
</script>

<style scoped>

.gbu-recalculate {
    height: 50px;
    text-align: center;
}

</style>